import { useQuery } from "@tanstack/react-query";

export function useAuthHook() {
  // First check localStorage for cached user data
  const cachedUser = localStorage.getItem('valuation_user');
  const initialUser = cachedUser ? JSON.parse(cachedUser) : null;
  const { data: user, isLoading } = useQuery({
    queryKey: ["auth_user"],
    queryFn: async () => {
      // If we have cached data, verify it with the server
      if (initialUser) {
        try {
          const response = await fetch('/api/auth/verify', {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('valuation_token')}`
            }
          });
          
          if (!response.ok) {
            // Token is invalid, clear local storage
            localStorage.removeItem('valuation_token');
            localStorage.removeItem('valuation_user');
            return null;
          }
          return initialUser;
        } catch (error) {
          return null;
        }
      }
      
      // If no cached user, fetch fresh data
      try {
        const response = await fetch('/api/auth/user', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('valuation_token')}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Not authenticated');
        }
        
        const userData = await response.json();
        localStorage.setItem('valuation_user', JSON.stringify(userData));
        return userData;
      } catch (error) {
        return null;
      }
    },
    initialData: initialUser, // Use cached data as initial data
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes stale time
  });

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
  };
}